import {createReducer} from 'redux-act';

import {
	fetchContextualPromptSuccess,
	fetchContextualPromptError,
	openContextualPrompt,
	closeContextualPrompt,
	declineContextualPrompt, fetchContextualPrompt,
	type IPrompt
} from 'modules/actions/user';


export interface IContextualPromptBannerReducer {
	prompt: IPrompt[];
	isOpen: boolean;
}

const initialState: IContextualPromptBannerReducer = {
	prompt: [],
	isOpen: true,
};

export const contextualPrompt = createReducer({}, initialState)
	.on(fetchContextualPrompt, (state: IContextualPromptBannerReducer) => {
		return {
			...state,
			prompt: [],
		};
	})
	.on(fetchContextualPromptSuccess, (state: IContextualPromptBannerReducer, payload) => {
		if (!payload) {
			return state;
		}
		return {
			...state,
			prompt: [...state.prompt, payload],
		};
	})
	.on(fetchContextualPromptError, (state: IContextualPromptBannerReducer) => {
		return {
			...state,
			prompt: [],
		};
	})
	.on(declineContextualPrompt, (state: IContextualPromptBannerReducer, payload) => {
		if (!payload) {
			return state;
		}
		return {
			...state,
			prompt: state.prompt.filter((item) => item.game !== payload.game),
		};
	})
	.on(openContextualPrompt, (state: IContextualPromptBannerReducer) => {
		return {
			...state,
			isOpen: true,
		};
	})
	.on(closeContextualPrompt, (state: IContextualPromptBannerReducer) => {
		return {
			...state,
			isOpen: false,
		};
	});
